import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantStatusEnum } from '../enums/tenant-status.enum';

/**
 * Tenant DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.TENANT)
export class TenantSearchDto extends BaseSearchDto {
  /** Lowered internal org id. */
  tenantOrgId!: string;
  /** Issued auth-provider organization id. */
  tenantAuthProviderOrgId!: string;
  tenantName!: string;
  tenantDatabase!: string;
  status!: TenantStatusEnum;
  notes?: string;
  files?: FileDto[];
  contactShortName?: string;

  displayValue(): string {
    return `${this.contactShortName}`;
  }

  shortDisplayValue(): string | null {
    return null;
  }

  periodDisplayValue(): string | null {
    return null;
  }

  extraDisplayValue(): string | null {
    return null;
  }

  pillDisplayValue(): string {
    return `${this.status}`;
  }
}
